import type { MouseEvent, ReactElement } from 'react';
import { goChats } from '../router';
import './ChatsBack.css';

/**
 * Back from a conversation to the Chats list (2026-10-20), for everyone signed
 * in (2026-10-21 Riley; until then only someone with something past Ember on
 * the list): the page-level Back's chevron (PageBack anatomy), carrying the count of
 * what is unread in every other conversation, hidden at nought (iMessage's
 * way). It lands on the list whatever the way in was — a room's link from a
 * text, the chat from home — popping to the list in the trail, or putting the
 * list in this entry's place (router.ts chatsBackFrom).
 */
export function ChatsBack({ count, className = '' }: { count: number; className?: string }): ReactElement {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>): void => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    goChats();
  };
  return (
    <a
      href="/chats"
      className={`ember-page-back chats-back${className ? ` ${className}` : ''}`}
      aria-label={count > 0 ? `Back to chats, ${count} unread` : 'Back to chats'}
      data-log="page_back"
      onClick={handleClick}
    >
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="m14.5 5-7 7 7 7" />
      </svg>
      {count > 0 && <span className="chats-back-count" aria-hidden>{count > 99 ? '99+' : count}</span>}
    </a>
  );
}
